<template>
  <div v-if="getLatestPromisePeriod(promisePeriods)" style="text-align: center">
    <div v-if="type === 'pct'">
      {{
        getPctDifferenceAsFormattedString(
          getLatestPromisePeriod(promisePeriods).difference_till_now_pct
        )
      }}%
    </div>
    <div v-else>
      {{
        getWhDifferenceAsFormattedString(
          getLatestPromisePeriod(promisePeriods).difference_till_now_wh
        )
      }}
    </div>
  </div>
</template>

<script lang="ts">
import type { PropType } from 'vue';
import type { YieldPromiseStatusJson } from '@/data/plants/YieldPromiseStatusJson.ts';
import Energy from '@/domain/model/unit/Energy.ts';

export default {
  name: 'PromiseDifferenceCell',
  props: {
    type: {
      type: String as PropType<'wh' | 'pct'>,
      required: true,
      validator: (value: string) => ['wh', 'pct'].includes(value),
    },
    promisePeriods: {
      type: Array as PropType<YieldPromiseStatusJson[]>,
      default: () => [],
    },
  },
  methods: {
    getLatestPromisePeriod(promises: YieldPromiseStatusJson[]) {
      return promises.length > 0 ? promises[promises.length - 1] : null;
    },
    getPctDifferenceAsFormattedString(value) {
      if (!value || value === 0) {
        return 0;
      }

      const isNegative = value < 0;
      return isNegative ? value : '+' + value;
    },
    getWhDifferenceAsFormattedString(value) {
      if (!value || value === 0) {
        return '0 Wh';
      }

      const energy = Energy.ofWh(Math.abs(value));
      const isNegative = value < 0;
      return isNegative ? '-' + energy.toString() : '+' + energy.toString();
    },
  },
};
</script>

<style scoped></style>
